module.exports = __webpack_public_path__ + "static/media/16-StrategiesForSurvivors.7756685e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/16-StrategiesForSurvivors.jpg
// module id = 150
// module chunks = 0